import { DashboardStateV2 } from "../types";

// Helper function to save state to localStorage
export function saveToLocalStorage(state: DashboardStateV2): DashboardStateV2 {
  localStorage.setItem("dashboardLayout", JSON.stringify(state));
  return state;
}